import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Tasks
export const getResponsabilidades = () => axios.get(`${API_BASE}/tasks/responsabilidades`);

export const getTasks = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
      params.append(key, filters[key]);
    }
  });
  return axios.get(`${API_BASE}/tasks?${params.toString()}`);
};

export const getTask = (taskId) => axios.get(`${API_BASE}/tasks/${taskId}`);

export const createTask = (data) => axios.post(`${API_BASE}/tasks`, data);

export const updateTask = (taskId, data) => axios.put(`${API_BASE}/tasks/${taskId}`, data);

export const deleteTask = (taskId) => axios.delete(`${API_BASE}/tasks/${taskId}`);

export const changeTaskStatus = (taskId, data) => axios.patch(`${API_BASE}/tasks/${taskId}/status`, data);

export const addCollaborator = (taskId, data) => axios.post(`${API_BASE}/tasks/${taskId}/collaborators`, data);

export const removeCollaborator = (taskId, userId) => axios.delete(`${API_BASE}/tasks/${taskId}/collaborators/${userId}`);

export const updateChecklist = (taskId, checklist) => axios.patch(`${API_BASE}/tasks/${taskId}/checklist`, { checklist });

// Comments
export const getComments = (taskId) => axios.get(`${API_BASE}/tasks/${taskId}/comments`);

export const createComment = (taskId, text) => axios.post(`${API_BASE}/tasks/${taskId}/comments`, { text });

// Attachments
export const getAttachments = (taskId) => axios.get(`${API_BASE}/tasks/${taskId}/attachments`);

export const uploadAttachment = (taskId, file, description = '', isMain = false) => {
  const formData = new FormData();
  formData.append('file', file);
  if (description) formData.append('description', description);
  formData.append('is_main', isMain);
  
  return axios.post(`${API_BASE}/tasks/${taskId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteAttachment = (taskId, attachmentId) => axios.delete(`${API_BASE}/tasks/${taskId}/attachments/${attachmentId}`);

// History
export const getTaskHistory = (taskId) => axios.get(`${API_BASE}/tasks/${taskId}/history`);

// Users
export const getUsers = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key]) params.append(key, filters[key]);
  });
  return axios.get(`${API_BASE}/users?${params.toString()}`);
};

// Areas, Departments, Tags
export const getAreas = () => axios.get(`${API_BASE}/areas`);
export const getDepartments = () => axios.get(`${API_BASE}/departments`);
export const getTags = () => axios.get(`${API_BASE}/tags`);

// Dashboard
export const getKPIs = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key]) params.append(key, filters[key]);
  });
  return axios.get(`${API_BASE}/dashboard/kpis?${params.toString()}`);
};

export const getAlerts = () => axios.get(`${API_BASE}/dashboard/alerts`);

export const getDepartmentsMetrics = (days = 7, areaId = null) => {
  const params = new URLSearchParams();
  params.append('days', days);
  if (areaId) params.append('area_id', areaId);
  return axios.get(`${API_BASE}/dashboard/departments?${params.toString()}`);
};

// Notifications
export const getNotifications = () => axios.get(`${API_BASE}/notifications`);
export const markAsRead = (notificationId) => axios.patch(`${API_BASE}/notifications/${notificationId}/read`);
export const markAllAsRead = () => axios.patch(`${API_BASE}/notifications/read-all`);
export const getUnreadCount = () => axios.get(`${API_BASE}/notifications/unread-count`);

// Weekly Updates (Seguimiento Semanal)
export const getWeeklyUpdates = (taskId) => axios.get(`${API_BASE}/tasks/${taskId}/weekly-updates`);
export const upsertWeeklyUpdate = (taskId, data) => axios.post(`${API_BASE}/tasks/${taskId}/weekly-updates`, data);
export const exportWeeklyExcel = (weekStart = null) => {
  const params = weekStart ? `?week_start=${weekStart}` : '';
  return axios.get(`${API_BASE}/reports/seguimiento-export${params}`, { responseType: 'blob' });
};
export const getSeguimientoStatus = (weekStart = null, includeCompleted = false) => {
  const params = new URLSearchParams();
  if (weekStart) params.append('week_start', weekStart);
  if (includeCompleted) params.append('include_completed', 'true');
  const qs = params.toString();
  return axios.get(`${API_BASE}/reports/seguimiento-status${qs ? '?' + qs : ''}`);
};

// Reports
export const closeWeek = (weekData = null) => axios.post(`${API_BASE}/reports/weekly/close`, weekData);
export const getWeeklyReport = (weekStartStr) => axios.get(`${API_BASE}/reports/weekly/${weekStartStr}`);
export const getPersonalWeeklyReport = (weeksAgo = 0) => axios.get(`${API_BASE}/reports/weekly-personal?weeks_ago=${weeksAgo}`);
export const listWeeklyReports = () => axios.get(`${API_BASE}/reports/weekly-list`);
export const checkWeekClosed = (weekStartStr) => axios.get(`${API_BASE}/reports/weekly/check/${weekStartStr}`);
export const getWeeklyStreak = () => axios.get(`${API_BASE}/reports/weekly-streak`);
export const sendFridayReminders = () => axios.post(`${API_BASE}/reports/send-friday-reminders`);

// Auth
export const inviteUser = (data) => axios.post(`${API_BASE}/auth/invite`, data);
export const changePassword = (password) => axios.post(`${API_BASE}/auth/change-password`, { password });

// User management
export const toggleUserActive = (userId) => axios.patch(`${API_BASE}/users/${userId}/toggle-active`);
export const forcePasswordChange = (userId) => axios.patch(`${API_BASE}/users/${userId}/force-password-change`);
export const getPendingInvitations = () => axios.get(`${API_BASE}/users/pending-invitations`);